module.exports = __webpack_public_path__ + "static/media/dentalCourses.5f81f80b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentalCourses.jpg
// module id = 495
// module chunks = 0